import React, { Component } from "react";
import { Dialog, IconButton, Button, Icon, Tooltip, Grid, FormControl, Select, InputLabel, Menu, MenuItem, List, ListItem, ListItemText, DialogActions, Chip, TextField } from "@material-ui/core";
import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actionCreators from '../../store/actions/index';
import { SingleSelect } from "react-select-material-ui";
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import moment from 'moment';
import DropdownDefault from "../Layout/DropdownDefault";
import CommonVisibiltyEdit from "../Layout/CommonVisibiltyEdit"
import CommonDisbledLock from "../Layout/CommonDisbledLock"

export const CreateFieldsDynamicTaskEdit = (data) => {
  var elements = data.state.fieldsList
  var fieldsArray = [];
  const formatCreateLabel = (value) => `Create "${value}"`;
  const isValidNewOption = (value) => value != "";

  const relatedOptions = data.state.relatedListArray;
  const options = relatedOptions && relatedOptions.map((option) => {
    const firstLetter = option.type;
    return {
      firstLetter: firstLetter,
      ...option,
    };
  });

  elements.map((v, i) => {

    if (v.fieldstatus === true) {
      if (v.fieldtype.id == '1' && v.id == '57') {
        fieldsArray.push(
          <>
            <Grid item xs={12}>
              <TextValidator
                type="text"
                id={v.id}
                disabled={(v.recordeditdefaultvalue == 3) ? true : false}
                className="w-100 input_bx"
                required={(v.recordcreationdefaultvalue == 2) ? true : false}
                label={'Name'}
                placeholder={"Add Name"}
                onChange={(event) => data.handleChange({ fieldid: v.id, taskvalue: event.target.value }, v.fieldkey)}
                ref={ref => data[v.fieldkey] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event, v.id, v.fieldkey)}
                name={v.fieldkey}
                value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].taskvalue : ""}
                validators={(v.recordeditdefaultvalue == 2) ? ["required"] : []}
                errorMessages={(v.recordeditdefaultvalue == 2) ? ["This field is required"] : []}
                InputLabelProps={{
                  shrink: true,
                  disableAnimation: false,
                  focused: true
                }}
              />
            </Grid>
          </>
        )
      } else if (v.fieldtype.id == '1' && v.fieldkey == 'tags') {
        var valTag = [];
        if (data.state.fieldsObj[v.fieldkey]) {
          valTag = data.state.fieldsObj[v.fieldkey].values
        }
        fieldsArray.push(<Grid item xs={12}>
          <InputLabel>Tags</InputLabel>
          <Autocomplete
            disableOpenOnFocus
            multiple
            value={valTag}
            filterSelectedOptions
            disabled={v.recordeditdefaultvalue == 3 ? true : false}
            name={v.fieldkey}
            id="tagInputId"
            options={data.state.systemTagsList.map(option => option.tagname)}
            freeSolo
            onChange={(event, value) => data.handleChange({ fieldid: v.id, values: value }, v.fieldkey, 'allowSubmitChange')}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip label={option.charAt(0).toUpperCase() + option.slice(1)} {...getTagProps({ index })} />
              ))
            }
            renderInput={params => (
              <TextValidator
                {...params}
                id={v.fieldkey}
                // label="Tags"
                placeholder="Add Tag"
                className="w-100 input_bx"
                ref={ref => data[v.fieldkey] = ref}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                onBlur={(event) => data.focusOutSubmitForm(event, v.id, v.fieldkey)}
                onFocus={() =>
                  setTimeout(() => {
                    document.getElementById("tagInputId").value = "";
                  }, 0)
                }
              />
            )}
          />
        </Grid>)
      } else if (v.fieldtype.id == '1' && v.id == '61') {//owner field
        var nameOwner = [];
        if (data.state.fieldsObj[v.fieldkey]) {
          nameOwner = data.state.fieldsObj[v.fieldkey].values
        }
        fieldsArray.push(<Grid item xs={12}>
          {/* <FormControl className="w-100 input_bx"> */}
          <InputLabel>Owner</InputLabel>
          <Autocomplete
            disableOpenOnFocus
            forcePopupIcon={false}
            name={v.fieldkey}
            options={data.state.usersListArray}
            getOptionLabel={option => option.name ? option.name : ""}
            value={nameOwner}
            disabled={v.recordeditdefaultvalue == 3 ? true : false}
            name={v.fieldkey}
            onChange={(event, value) => data.handleChange({ fieldid: v.id, values: value }, v.fieldkey, 'allowSubmitChange')}
            id={v.id}
            renderInput={params => (
              <TextValidator
                ref={ref => data[v.fieldkey] = ref}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                onBlur={(event) => data.focusOutSubmitForm(event, v.id, v.fieldkey)}
                {...params}
                variant="standard"
                // label={"Owner"}
                fullWidth
                className="input_bx"
              />
            )}
          />
          {/* </FormControl> */}
        </Grid>)
      } else if (v.fieldtype.id == '1' && v.id == '59') { // related field
        var relatedVal = [];
        if (data.state.fieldsObj[v.fieldkey]) {
          relatedVal = data.state.fieldsObj[v.fieldkey].values
        }
        fieldsArray.push(<Grid item xs={12}>
          {/* <FormControl className="w-100 input_bx"> */}
          <InputLabel>Related To</InputLabel>
          <Autocomplete
            disableOpenOnFocus
            name={v.fieldkey}
            options={options}
            groupBy={(option) => option.firstLetter.toUpperCase()}
            getOptionLabel={(option) => option.name}
            value={relatedVal}
            disabled={v.recordcreationdefaultvalue == 3 ? true : false}
            name={v.fieldkey}
            onChange={(event, value) => data.handleChange({ fieldid: v.id, values: value }, v.fieldkey, 'allowSubmitChange')}
            id={v.id}
            renderInput={params => (
              <TextValidator
                ref={ref => data[v.fieldkey] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event, v.id, v.fieldkey)}
                {...params}
                variant="standard"
                // label={v.fieldlabel}
                className=" input_bx"
                fullWidth
                name={v.fieldkey}
                placeholder="Add Relation"
                value={relatedVal && relatedVal.length ? 1 : null}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                required={(v.recordcreationdefaultvalue == 2) ? true : false}
                validators={(v.recordcreationdefaultvalue == 2 && (relatedVal == null || relatedVal.length == 0)) ? ["required"] : []}
                errorMessages={(v.recordcreationdefaultvalue == 2 && (relatedVal == null || relatedVal.length == 0)) ? ["This field is required"] : []}
              />
            )}
          />
          {/* </FormControl> */}
        </Grid >)
      } else if (v.fieldtype.id == '1' && v.id == '23') {
        fieldsArray.push(
          <>
            {data.state.focusValue &&
              <Grid item xs={4}>
                {/* <FormControl className="w-100 input_bx"> */}
                <InputLabel>{v.fieldlabel}</InputLabel>
                <SelectValidator
                  className="w-100 input_bx"
                  ref={ref => data[v.fieldkey] = ref}
                  label={v.fieldlabel}
                  value={data.state.companyCurrencyData.currencyid}
                  disabled={v.recordeditdefaultvalue == 3 ? true : false}
                  name={"currency"}
                  id={"currency"}
                  SelectProps={{ onClose: data.currencyDropdownClose }}
                >
                  <MenuItem className="select-menu-item item-with-link" value={data.state.companyCurrencyData.currencyid}>{data.state.companyCurrencyData.detail.code}</MenuItem>
                </SelectValidator>
                {/* </FormControl> */}
              </Grid >
            }
            <Grid item xs={data.state.focusValue ? 8 : 12} row className={data.state.focusValue ? "checkbox-margin-18" : ""}>
              <InputLabel>{v.fieldlabel}</InputLabel>
              <TextValidator
                type="number"
                pattern="[0-9]*"
                id={v.id}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                className="w-100 input_bx"
                onFocus={data.focusInValue}
                // label={!data.state.focusValue ? v.fieldlabel : ""}
                onChange={(event) => data.handleChange({ fieldid: v.id, taskvalue: event.target.value }, v.fieldkey)}
                ref={ref => data[v.fieldkey] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event, v.id, v.fieldkey)}
                name={v.fieldkey}
                placeholder={"Add Value"}
                value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].taskvalue : ""}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {data.state.companyCurrencyData.symbol}
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
          </>
        )
      } else if (v.fieldtype.id == '1') {
        fieldsArray.push(<Grid item xs={12}>
          <InputLabel>{v.fieldlabel}</InputLabel>
          <TextValidator
            type="text"
            id={v.id}
            disabled={v.recordeditdefaultvalue == 3 ? true : false}
            className="w-100 input_bx"
            placeholder={"Add " + v.fieldlabel}
            // label={v.fieldlabel}
            onChange={(event) => data.handleChange({ fieldid: v.id, taskvalue: event.target.value }, v.fieldkey)}
            ref={ref => data[v.fieldkey] = ref}
            onBlur={(event) => data.focusOutSubmitForm(event, v.id, v.fieldkey)}
            name={v.fieldkey}
            value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].taskvalue : ""}
            validators={v.recordcreationdefaultvalue == 2 ? ["required"] : []}
            errorMessages={
              v.recordcreationdefaultvalue == 2
                ? ["This field is required", "Please enter a valid domain"]
                : []
            }
          />
        </Grid>)
      } else if (v.fieldtype.id == '9') {
        fieldsArray.push(<Grid item xs={12}>
          <InputLabel>{v.fieldlabel}</InputLabel>
          <TextValidator
            type="text"
            id={v.id}
            disabled={v.recordeditdefaultvalue == 3 ? true : false}
            className="w-100 input_bx"
            placeholder={"Add " + v.fieldlabel}
            // label={v.fieldlabel}
            onChange={(event) => data.handleChange({ fieldid: v.id, taskvalue: event.target.value }, v.fieldkey)}
            ref={ref => data[v.fieldkey] = ref}
            onBlur={(event) => data.focusOutSubmitForm(event, v.id, v.fieldkey)}
            name={v.fieldkey}
            value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].taskvalue : ""}
            validators={v.recordcreationdefaultvalue == 2 ? ["required", "IsURLValid"] : ["IsURLValid"]}
            errorMessages={
              v.recordcreationdefaultvalue == 2
                ? ["This field is required", "Please enter a valid domain"]
                : ["Please enter a valid domain"]
            }
          />
        </Grid>)
      }
      else if (v.fieldtype.id == '6' || v.fieldtype.id == '10' || v.fieldtype.id == '7') {
        fieldsArray.push(<Grid item xs={12}>
          <InputLabel>{v.fieldlabel}</InputLabel>
          <TextValidator
            type="number"
            id={v.id}
            disabled={v.recordeditdefaultvalue == 3 ? true : false}
            className="w-100 input_bx"
            placeholder={"Add " + v.fieldlabel}
            onChange={(event) => data.handleChange({ fieldid: v.id, taskvalue: event.target.value }, v.fieldkey)}
            ref={ref => data[v.fieldkey] = ref}
            onBlur={(event) => data.focusOutSubmitForm(event, v.id, v.fieldkey)}
            name={v.fieldkey}
            value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].taskvalue : ""}
          />
        </Grid>)
      }

      if (v.fieldtype.id == '2' && v.id == "25") {//Address Fields.
        var displayMapLink = false;
        var mapAddress = "";

        if (data.state.fieldsObj[v.fieldkey] && data.state.fieldsObj[v.fieldkey].taskvalue != "" || data.state.city || data.state.state || data.state.country || data.state.zipcode) {
          displayMapLink = true
          var line1 = ""

          if (data.state.fieldsObj[v.fieldkey] != undefined) {
            line1 = data.state.fieldsObj[v.fieldkey].taskvalue
          }
          var line2 = data.state.city
          var line3 = data.state.state
          var line4 = (data.state.country && data.state.country.name) ? data.state.country.name : "";
          var line5 = data.state.zipcode
          var mapAddress = encodeURI(line1 + " " + line2 + " " + line3 + " " + line5 + " " + line4);
        }
        fieldsArray.push(
          <>
            {displayMapLink &&
              <Grid item xs={12}>
                <a className="pull-right" style={{ color: '#7467ef' }} target="_blank" href={"https://maps.google.com/?q=" + mapAddress}>Address Map</a>
              </Grid>
            }
            <Grid item xs={12}>
              <TextValidator
                multiline
                type="text"
                id={v.id}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                className="w-100 input_bx"
                label={v.fieldlabel}
                onChange={(event) => data.handleChange({ fieldid: v.id, taskvalue: event.target.value }, v.fieldkey)}
                ref={ref => data[v.fieldkey] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event, v.id, v.fieldkey)}
                name={v.fieldkey}
                value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].taskvalue : ""}
              />
            </Grid>
            <Grid item xs={4}>
              <TextValidator
                type="text"
                id={"city"}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                className="w-100 input_bx"
                label={"City"}
                onChange={(event) => data.handleNormalFields(event)}
                ref={ref => data['city'] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event, v.id, 'city')}
                name={"city"}
                value={data.state.city}


              />
            </Grid>
            <Grid item xs={4}>
              <TextValidator
                type="text"
                id={"state"}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                className="w-100 input_bx"
                label={"State"}
                onChange={(event) => data.handleNormalFields(event)}
                ref={ref => data['addressState'] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event, v.id, 'addressState')}
                name={"addressState"}
                value={data.state.addressState}


              />
            </Grid>
            <Grid item xs={4}>
              <TextValidator
                type="text"
                id={"zipcode"}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                className="w-100 input_bx"
                label={"Zip code"}
                onChange={(event) => data.handleNormalFields(event)}
                ref={ref => data['zipcode'] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event, v.id, 'zipcode')}
                name={"zipcode"}
                value={data.state.zipcode}


              />
            </Grid>
            <Grid item xs={12}>
              <FormControl className="w-100 input_bx">
                <Autocomplete
                  disableOpenOnFocus
                  forcePopupIcon={false}
                  disabled={v.recordeditdefaultvalue == 3 ? true : false}
                  name={"country"}
                  onChange={data.handleCountryChange}
                  id={"country"}
                  value={data.state.country}
                  options={data.state.countryListArray}
                  getOptionLabel={option => option.name ? option.name : ""}
                  renderInput={params => (
                    <TextValidator
                      ref={ref => data['country'] = ref}
                      onBlur={(event) => data.focusOutSubmitForm(event, v.id, 'country')}
                      {...params}
                      variant="standard"
                      label={"Country"}
                      fullWidth
                      className=" input_bx"
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </>
        )
      } else if (v.fieldtype.id == '2' && v.id == "64") {
        let testa = data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].taskvalue : ""
        fieldsArray.push(<Grid item xs={12}>
          <InputLabel>{v.fieldlabel}</InputLabel>
          {
            data.validateUrl(testa) && data.state.hasEdit === false ?
              <div className="w-100 input_bx font-size-14 text_link" style={{ wordBreak: "break-word" }} onClick={() => data.handlehasEdit()}>
                <a target="_blank" href={testa}>{testa}</a>
              </div>
              :
              <TextValidator
                multiline
                type="text"
                id={v.id}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                className="w-100 input_bx"
                // label={v.fieldlabel}
                placeholder={"Add " + v.fieldlabel}
                onChange={(event) => data.handleChange({ fieldid: v.id, taskvalue: event.target.value }, v.fieldkey)}
                ref={ref => data[v.fieldkey] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event, v.fieldkey)}
                name={v.fieldkey}
                value={testa}
              />
          }
        </Grid>)
      } else if (v.fieldtype.id == '2') {
        fieldsArray.push(<Grid item xs={12}>
          <InputLabel>{v.fieldlabel}</InputLabel>
          <TextValidator
            multiline
            type="text"
            id={v.id}
            disabled={v.recordeditdefaultvalue == 3 ? true : false}
            className="w-100 input_bx"
            // label={v.fieldlabel}
            placeholder={"Add " + v.fieldlabel}
            onChange={(event) => data.handleChange({ fieldid: v.id, taskvalue: event.target.value }, v.fieldkey)}
            ref={ref => data[v.fieldkey] = ref}
            onBlur={(event) => data.focusOutSubmitForm(event, v.id, v.fieldkey)}
            name={v.fieldkey}
            value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].taskvalue : ""}
          />
        </Grid>)
      }

      if (v.fieldtype.id == '4') {
        if (v.id === "65" || v.id === "58" || v.id === "63") {
          var valDropdown = "null";
          if (v.options && data.state.fieldsObj[v.fieldkey] && data.state.fieldsObj[v.fieldkey].values) {
            valDropdown = v.options.filter(row => row.id == data.state.fieldsObj[v.fieldkey].values.id)[0]
          }
          //set Visibility
          if (v.id === "65") {
            fieldsArray.push(
              <CommonVisibiltyEdit data={data} v={v} />
            )
          } else if (v.id === "58") {
            fieldsArray.push(<Grid item xs={12}>
              <InputLabel>{v.fieldlabel}</InputLabel>
              <SelectValidator
                ref={ref => data[v.fieldkey] = ref}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                value={valDropdown}
                onChange={(event) => data.handleChange({ fieldid: v.id, values: event.target.value }, v.fieldkey, 'allowSubmitChange')}
                name={v.fieldkey}
                id={v.id}
                className="w-100 input_bx"

              >
                {v.options && v.options.map((item, key) =>
                  <MenuItem className="select-menu-item w-100 input_bx" key={item.id} value={item}>{item.name}</MenuItem>
                )}
                {v.options && v.id == "19" &&
                  <MenuItem className="select-menu-item item-with-link" value={5}><Link to="/settings/task-types">Customize task Types</Link></MenuItem>
                }
              </SelectValidator>
            </Grid >
            )
          } else {
            fieldsArray.push(<Grid item xs={12}>
              <InputLabel>{v.fieldlabel}</InputLabel>
              <SelectValidator
                ref={ref => data[v.fieldkey] = ref}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                value={valDropdown}
                onChange={(event) => data.handleChange({ fieldid: v.id, values: event.target.value }, v.fieldkey, 'allowSubmitChange')}
                name={v.fieldkey}
                id={v.id}
                className="w-100 input_bx"
              >
                <MenuItem value="null" style={{display:'none'}} disabled><span className="text-hint">{`Add ${v.fieldlabel && v.fieldlabel.charAt(0).toUpperCase() + v.fieldlabel.slice(1)}`}</span></MenuItem>
                {v.options && v.options.map((item, key) =>
                  <MenuItem className="select-menu-item w-100 input_bx" key={item.id} value={item}>{item.name}</MenuItem>
                )}
              </SelectValidator>
            </Grid >
            )
          }
        } else {
          var valDropdown = "null";
          if (v.options && data.state.fieldsObj[v.fieldkey] && data.state.fieldsObj[v.fieldkey].values) {
            valDropdown = v.options.filter(row => row.id == data.state.fieldsObj[v.fieldkey].values.id)[0]
          }
          fieldsArray.push(<Grid item xs={12}>
            <InputLabel>{v.fieldlabel}</InputLabel>
            <SelectValidator
              ref={ref => data[v.fieldkey] = ref}
              disabled={v.recordeditdefaultvalue == 3 ? true : false}
              value={valDropdown}
              onChange={(event) => data.handleChange({ fieldid: v.id, values: event.target.value }, v.fieldkey, 'allowSubmitChange')}
              name={v.fieldlabel}
              id={v.id}
              className="w-100 input_bx"
            >
              <MenuItem value="null" style={{display:'none'}} disabled><span className="text-hint">{`Add ${v.fieldlabel && v.fieldlabel.charAt(0).toUpperCase() + v.fieldlabel.slice(1)}`}</span></MenuItem>
              {v.options && v.options.map((item, key) =>
                <MenuItem className="select-menu-item w-100 input_bx" key={item.id} value={item}>{item.optionvalue}</MenuItem>
              )}

            </SelectValidator>
          </Grid >
          )
        }
      }
      if (v.fieldtype.id == '5') {//multi dropdown
        var multiSelectedVal = [];
        if (data.state.fieldsObj[v.fieldkey] && data.state.fieldsObj[v.fieldkey].values && data.state.fieldsObj[v.fieldkey].values.length > 0) {
          multiSelectedVal = v.options.filter(row => data.state.fieldsObj[v.fieldkey].values.filter(val => val.id == row.id).length);
        }

        fieldsArray.push(<Grid item xs={12}>
          <InputLabel>{v.fieldlabel}</InputLabel>
          <Autocomplete
            multiple
            value={multiSelectedVal}
            disabled={v.recordeditdefaultvalue == 3 ? true : false}
            name={v.fieldkey}
            onChange={(event, value) => data.handleChange({ fieldid: v.id, values: value }, v.fieldkey, 'allowSubmitChange')}
            id={v.id}
            options={v.options}
            getOptionLabel={option => option.optionvalue}
            renderInput={params => (
              <TextValidator
                ref={ref => data[v.fieldkey] = ref}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                onBlur={(event) => data.focusOutSubmitForm(event, v.id, v.fieldkey)}
                {...params}
                variant="standard"
                placeholder={"Add " + v.fieldlabel}
                fullWidth
                className="w-100 input_bx"
              />
            )}
          />
        </Grid >
        )
      }
      if (v.fieldtype.id == '3') {//checkbox field
        fieldsArray.push(<Grid item xs={12}>
          <FormControl className="w-100 input_bx">
            <FormControlLabel
              control={
                <Checkbox
                  name={v.fieldkey}
                  disabled={v.recordeditdefaultvalue == 3 ? true : false}
                  id={v.id}
                  checked={(data.state.fieldsObj[v.fieldkey] && data.state.fieldsObj[v.fieldkey].taskvalue == "1") ? true : false}
                  onChange={(event, value) => data.handleChange({ fieldid: v.id, taskvalue: value ? "1" : "0" }, v.fieldkey, 'allowSubmitChange')}
                  value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].taskvalue : ""}
                  color="primary"
                />
              }
              label={<span className="font-size-13">{v.fieldlabel}</span>}
            />
          </FormControl>
        </Grid >
        )
      }
      if (v.fieldtype.id == '8') {//datepicker field
        var max = "";
        var errorMsg = "Please enter value ";
        var dtFormat = "MM/dd/yyyy";
        var selectedDate = data.state.selectedDate;
        if (data.state.fieldsObj[v.fieldkey]) {
          selectedDate = data.state.fieldsObj[v.fieldkey].values
        }

        var selectedDate1 = data.state.selectedDate1;
        if (data.state.fieldsObj['reminderdate']) {
          selectedDate1 = data.state.fieldsObj['reminderdate'].values
        }

        if (data.state.userSettings != "") {
          dtFormat = data.state.userSettings.dateformat;
          dtFormat = dtFormat.replace("DD", "dd").replace("YYYY", "yyyy");
        }

        if (data.state.repeattype == "days") {
          max = "maxNumber:365";
          errorMsg += " 365 or less.";
        } else if (data.state.repeattype == "weeks") {
          max = "maxNumber:52";
          errorMsg += " 52 or less.";
        } else {
          max = "maxNumber:12";
          errorMsg += " 12 or less.";
        }

        if (v.id == "60") {
          fieldsArray.push(<>
            <Grid item xs={12} style={{ marginTop: '14px' }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container spacing={3}>
                  <Grid item xs={6} className="pt-0">
                    <KeyboardDatePicker
                      className="input_bx"
                      label={v.fieldlabel}
                      format={dtFormat}
                      required={(v.recordcreationdefaultvalue == 2) ? true : false}
                      disabled={v.recordeditdefaultvalue == 3 ? true : false}
                      placeholder={dtFormat}
                      error={(v.recordcreationdefaultvalue == 2 && selectedDate == null || selectedDate == "Invalid Date") ? true : false}
                      value={selectedDate}
                      onChange={(event, value) => data.handleChange({ fieldid: v.id, values: event == "Invalid Date" ? "Invalid Date" : event }, v.fieldkey, 'allowSubmitChange')}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      helperText={(v.recordcreationdefaultvalue == 2 && selectedDate == null) ? "This field is required" : (selectedDate == "Invalid Date") ? "Please enter a valid date." : ""}
                    />
                  </Grid>
                  <Grid item xs={6} className="pt-0">
                    <KeyboardTimePicker
                      label={"Time"}
                      className=" input_bx"
                      format="hh:mm a"
                      required={(v.recordcreationdefaultvalue == 2) ? true : false}
                      disabled={v.recordeditdefaultvalue == 3 ? true : false}
                      placeholder={dtFormat}
                      error={(v.recordcreationdefaultvalue == 2 && selectedDate == null || selectedDate == "Invalid Date") ? true : false}
                      value={selectedDate}
                      onChange={(event, value) => data.handleChange({ fieldid: v.id, values: event == "Invalid Date" ? "Invalid Date" : event }, v.fieldkey, 'allowSubmitChange')}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      helperText={(v.recordcreationdefaultvalue == 2 && selectedDate == null) ? "This field is required" : (selectedDate == "Invalid Date") ? "Please enter a valid date." : ""}
                    />
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} style={{ padding: '0' }}>
              <DropdownDefault
                menuButton={
                  <p style={{
                    color: '#7467ef',
                    textDecoration: 'underline',
                    cursor: "pointer",
                    marginLeft: '5px',
                    display: 'block',
                  }}
                  >
                    {data.state.selectedRepeatValue != 'never' && <Icon style={{ fontSize: "16px", marginBottom: '-4px' }}>repeat</Icon>}
                    <span style={{ marginLeft: '2px', fontSize: '12px' }}>{data.state.selectedRepeatName}</span>
                  </p>
                }
              >
                <MenuItem onClick={() => data.changeRepeatOption('never', 'Set to repeat', 0)} className="flex flex-middle">Never</MenuItem>
                <MenuItem onClick={() => data.changeRepeatOption('daily', 'Daily', 1)} className="flex flex-middle">Daily</MenuItem>
                <MenuItem onClick={() => data.changeRepeatOption('weekly', 'Weekly', 7)} className="flex flex-middle">Weekly</MenuItem>
                <MenuItem onClick={() => data.changeRepeatOption('monthly', 'Monthly', 30)} className="flex flex-middle">Monthly</MenuItem>
                <MenuItem onClick={() => data.changeRepeatOption('yearly', 'Yearly', 365)} className="flex flex-middle">Yearly</MenuItem>
                <MenuItem onClick={() => data.changeRepeatOption('custom', 'Custom', 0)} className="flex flex-middle">Custom</MenuItem>
              </DropdownDefault>
            </Grid>

            {data.state.selectedRepeatValue == 'custom' && <><Grid item xs={4}>
              <TextValidator
                ref={ref => data[v.fieldkey] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event, v.id, v.fieldkey)}

                type="number"
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                className="w-100 input_bx"
                label={"Repeat every"}
                onChange={(event) => data.handleNormalFields(event)}
                name={"repeatdays"}
                value={data.state.repeatdays}
                validators={["isNumber", "minNumber:1", max]}
                errorMessages={[
                  "Please enter a valid number format",
                  "Please enter a value greater than 0",
                  errorMsg
                ]
                }
              />
            </Grid>
              <Grid item xs={3}>
                <FormControl className="w-100 input_bx" style={{ marginTop: '14px' }}>
                  <SelectValidator
                    ref={ref => data['repeattype'] = ref}
                    value={data.state.repeattype}
                    onChange={(event) => data.handleNormalFields(event)}
                    disabled={v.recordeditdefaultvalue == 3 ? true : false}
                    name={"repeattype"}
                    id={"repeattype"}
                  >
                    <MenuItem className="select-menu-item w-100 input_bx" value={"days"}>Days</MenuItem>
                    <MenuItem className="select-menu-item w-100 input_bx" value={"weeks"}>Weeks</MenuItem>
                    <MenuItem className="select-menu-item w-100 input_bx" value={"months"}>Months</MenuItem>
                  </SelectValidator>
                </FormControl>
              </Grid>
              <Grid item xs={5}>

              </Grid>
            </>
            }

            <Grid item xs={12} style={{ padding: '0' }}>
              <DropdownDefault
                menuButton={
                  <p style={{
                    color: '#7467ef',
                    textDecoration: 'underline',
                    cursor: "pointer",
                    marginLeft: '5px',
                    display: 'block',
                  }}
                  >
                    {data.state.selectedReminderValue != '0' && <Icon style={{ fontSize: "16px", marginBottom: '-4px' }}>notifications</Icon>}
                    <span style={{ marginLeft: '2px', fontSize: '12px', margin: '0' }}>{data.state.selectedReminderName}</span>
                  </p>
                }
              >
                <MenuItem onClick={() => data.changeReminderOption('0', 'Add a reminder', 0)} className="flex flex-middle">No reminder</MenuItem>
                <MenuItem onClick={() => data.changeReminderOption('1', '30 minutes before', 30)} className="flex flex-middle">30 minutes before</MenuItem>
                <MenuItem onClick={() => data.changeReminderOption('2', '1 hour before', 60)} className="flex flex-middle">1 hour before</MenuItem>
                <MenuItem onClick={() => data.changeReminderOption('3', '1 day before', 1440)} className="flex flex-middle">1 day before</MenuItem>
                <MenuItem onClick={() => data.changeReminderOption('4', '1 week before', 10080)} className="flex flex-middle">1 week before</MenuItem>
                <MenuItem onClick={() => data.changeReminderOption('5', 'Custom', 0)} className="flex flex-middle">Custom</MenuItem>
              </DropdownDefault>
            </Grid>
            {data.state.selectedReminderValue == "5" &&
              <Grid item xs={12} style={{ marginTop: '14px' }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container spacing={3}>
                    <Grid item xs={6} className="pt-0">
                      <KeyboardDatePicker
                        label={"Reminder Date"}
                        className="input_bx"
                        format={dtFormat}
                        required={(v.recordcreationdefaultvalue == 2) ? true : false}
                        disabled={v.recordeditdefaultvalue == 3 ? true : false}
                        placeholder={dtFormat}
                        error={(v.recordcreationdefaultvalue == 2 && selectedDate1 == null || selectedDate1 == "Invalid Date") ? true : false}
                        value={selectedDate1}
                        onChange={(event, value) => data.handleChange({ fieldid: '62', values: event == "Invalid Date" ? "Invalid Date" : event }, "reminderdate", 'allowSubmitChange')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        helperText={(v.recordcreationdefaultvalue == 2 && selectedDate == null) ? "This field is required" : (selectedDate1 == "Invalid Date") ? "Please enter a valid date." : ""}
                      />
                    </Grid>
                    <Grid item xs={6} className="pt-0">
                      <KeyboardTimePicker
                        label={"Time"}
                        className=" input_bx"
                        format="hh:mm a"
                        required={(v.recordcreationdefaultvalue == 2) ? true : false}
                        disabled={v.recordeditdefaultvalue == 3 ? true : false}
                        placeholder={dtFormat}
                        error={(v.recordcreationdefaultvalue == 2 && selectedDate1 == null || selectedDate1 == "Invalid Date") ? true : false}
                        value={selectedDate1}
                        onChange={(event, value) => data.handleChange({ fieldid: '62', values: event == "Invalid Date" ? "Invalid Date" : event }, "reminderdate", 'allowSubmitChange')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        helperText={(v.recordcreationdefaultvalue == 2 && selectedDate1 == null) ? "This field is required" : (selectedDate1 == "Invalid Date") ? "Please enter a valid date." : ""}
                      />
                    </Grid>
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>
            }

          </>)
        } else if (v.id != "62") {
          fieldsArray.push(<Grid item xs={12} >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <FormControl className="w-100">
                <KeyboardDatePicker
                  className="w-100 input_bx"
                  label={v.fieldlabel}
                  format={dtFormat}
                  required={(v.recordcreationdefaultvalue == 2) ? true : false}
                  disabled={v.recordeditdefaultvalue == 3 ? true : false}
                  placeholder={dtFormat}
                  error={(v.recordcreationdefaultvalue == 2 && selectedDate == null || selectedDate == "Invalid Date") ? true : false}
                  value={selectedDate}
                  onChange={(event, value) => data.handleChange({ fieldid: v.id, values: event == "Invalid Date" ? "Invalid Date" : event }, v.fieldkey, 'allowSubmitChange')}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  helperText={(v.recordcreationdefaultvalue == 2 && selectedDate == null) ? "This field is required" : (selectedDate == "Invalid Date") ? "Please enter a valid date." : ""}

                />
              </FormControl>
            </MuiPickersUtilsProvider>
          </Grid>
          )
        }
      }
    }
  })

  return fieldsArray;
}